import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { EventService } from 'src/services/event.service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LiveeventComponent } from './components/liveevent/liveevent.component';
import { LoggedInGuard } from './guards/loggedin.guard';
import { AuthService } from './services/auth.service';
import { StatisticsService } from './services/statistics.service';
import { ViewManagerService } from './services/views/view-manager.service';
import { ActivityManagerService } from './services/views/activity-manager.service';

@NgModule({
  declarations: [
    AppComponent,
    LiveeventComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [
    EventService,
    AuthService,
    StatisticsService,
    ViewManagerService,
    ActivityManagerService,
    LoggedInGuard,
    provideHttpClient(withInterceptorsFromDi())
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
